import { render, staticRenderFns } from "./RestaurateurLayout.vue?vue&type=template&id=52669cbe&"
import script from "./RestaurateurLayout.vue?vue&type=script&lang=js&"
export * from "./RestaurateurLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports